import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export default function Login() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const { search } = useLocation();
    const params = new URLSearchParams(search);
    const next = params.get("next") || "/dashboard";
    const [form, setForm] = useState({ email: "", password: "" });
    const [loading, setLoading] = useState(false);

    async function onSubmit(e) {
        e.preventDefault();
        setLoading(true);
        try {
            await login(form.email, form.password);
            toast.success("Welcome back.");
            navigate({ pathname: next, search });
        } catch (err) {
            toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
        } finally {
            setLoading(false);
        }
    }

    return (
        <div data-testid="login-page" className="mx-auto flex min-h-[80vh] max-w-md flex-col justify-center px-6 py-16">
            <div className="caption text-[var(--brand-accent)]">Recruiter Access</div>
            <h1 className="mt-3 font-serif text-5xl tracking-display text-[#FAFAFA]">Sign in</h1>
            <form onSubmit={onSubmit} className="mt-10 space-y-5">
                <Field label="Email">
                    <input
                        data-testid="input-email"
                        type="email"
                        required
                        value={form.email}
                        onChange={(e) => setForm({ ...form, email: e.target.value })}
                        className="w-full rounded-sm border border-white/10 bg-white/[0.03] px-4 py-3 text-sm text-[#FAFAFA] focus:border-[var(--brand-accent)] focus:outline-none"
                    />
                </Field>
                <Field label="Password">
                    <input
                        data-testid="input-password"
                        type="password"
                        required
                        value={form.password}
                        onChange={(e) => setForm({ ...form, password: e.target.value })}
                        className="w-full rounded-sm border border-white/10 bg-white/[0.03] px-4 py-3 text-sm text-[#FAFAFA] focus:border-[var(--brand-accent)] focus:outline-none"
                    />
                </Field>
                <button
                    data-testid="btn-login"
                    type="submit"
                    disabled={loading}
                    className="w-full rounded-sm py-3.5 text-sm font-medium transition-all duration-300 hover:shadow-[0_0_24px_rgba(201,169,110,0.35)] disabled:opacity-50"
                    style={{ background: "var(--brand-accent)", color: "#0A0A0A" }}
                >
                    {loading ? "Signing in…" : "Sign in"}
                </button>
            </form>
            <p className="mt-8 text-sm text-[#A3A3A3]">
                New here?{" "}
                <Link to={{ pathname: "/register", search }} className="text-[var(--brand-accent)] hover:underline" data-testid="link-register">
                    Apply to recruit
                </Link>
            </p>
            <p className="mt-3 caption text-[#737373]">
                Demo · admin@sovereign.com / Sovereign2026!
            </p>
        </div>
    );
}

function Field({ label, children }) {
    return (
        <label className="block">
            <span className="caption text-[#737373]">{label}</span>
            <div className="mt-2">{children}</div>
        </label>
    );
}
